//#region Imports

import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { ButtonTypeEnum } from '../../shared/components/button/types/button-type.enum';
import { ButtonRadiusEnum } from '../../shared/components/button/types/button-radius.enum';
import { AnimatedBannerComponent } from '../../shared/components/animated-banner/animated-banner.component';
import { ButtonSizeEnum } from '../../shared/components/button/types/button-size.enum';

//#endregion

@Component({
  selector: 'l-not-found',
  standalone: true,
  imports: [
    ButtonComponent,
    AnimatedBannerComponent
  ],
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {
  
  //#region Constructor

  constructor(private readonly router: Router) {}

  //#endregion
  
  //#region Public Properties

  public buttonTypes: typeof ButtonTypeEnum = ButtonTypeEnum;

  public buttonRadius: typeof ButtonRadiusEnum = ButtonRadiusEnum;

  public buttonSizes: typeof ButtonSizeEnum = ButtonSizeEnum;

  //#endregion

  //#region Public Methods

  public goToLogin(): void {
    this.router.navigate(['/login']);
  }

  //#endregion
}
